import { render } from "./FornitoreAudit.vue?vue&type=template&id=47cad979&ts=true"
import script from "./FornitoreAudit.vue?vue&type=script&lang=ts"
export * from "./FornitoreAudit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__